import { CheckCircle } from "lucide-react";
import { DragEvent, useState, ReactNode } from "react";
import { Policy } from ".";

function PolicyCard({
  policy,
  isDisabled,
  renderIconByName
}: {
  policy: Policy;
  isDisabled: boolean;
  renderIconByName: (iconName: string) => ReactNode;
}) {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragStart = (e: DragEvent<HTMLDivElement>) => {
    if (isDisabled) {
      e.preventDefault();
      return;
    }

    setIsDragging(true);
    e.dataTransfer.effectAllowed = "copy";
    e.dataTransfer.setData("text/plain", policy.id); // For better browser support
    e.dataTransfer.setData(
      "application/json",
      JSON.stringify({ type: "POLICY", policy }),
    );

    // Create drag image
    const dragImage = e.currentTarget.cloneNode(true) as HTMLElement;
    dragImage.style.opacity = "0.8";
    document.body.appendChild(dragImage);
    e.dataTransfer.setDragImage(dragImage, 0, 0);
    setTimeout(() => document.body.removeChild(dragImage), 0);
  };

  const handleDragEnd = () => {
    setIsDragging(false);
  };

  return (
    <div
      draggable={!isDisabled}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      className={`policy-item ${isDisabled ? "disabled" : ""} ${isDragging ? "dragging" : ""}`}
    >
      {isDisabled && (
        <div className="policy-check-badge">
          <CheckCircle />
        </div>
      )}
      <div className={`policy-icon ${policy.iconColor}`}>{renderIconByName(policy.icon)}</div>
      <p className="policy-name">{policy.name}</p>
    </div>
  );
}
export default PolicyCard;
